import type { iProfitAllocationRecord } from "@sdk/profit-allocation-records/profit-allocation-record-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectProfitAllocationRecordQueryMap,
  selectEntityMap: selectProfitAllocationRecordsMap,
  selectQueryMapAll: selectProfitAllocationRecordsMapAll,
  selectQueryAllList: selectProfitAllocationRecordsAllList,
  selectAllEntities: selectAllProfitAllocationRecords,
  selectAllEntitiesQuery: selectAllProfitAllocationRecordsQuery,
  selectEntityById: selectProfitAllocationRecordById,
  selectEntityQuery: selectProfitAllocationRecordQuery,
  selectEntityQueryList: selectProfitAllocationRecordQueryList,
} = CreateSelectorForEntities<iStore, iProfitAllocationRecord>({
  sliceName: "profitAllocationRecords",
});
